'use strict';

/* eslint new-cap: 0 */
/* eslint no-undef: 0 */
/* eslint camelcase: 0 */
var environment = window.gSTB.GetEnv(JSON.stringify({varList: [
    'Image_Date',
    'Image_Desc',
    'Image_Version',
    'acPassword',
    'accessControl',
    'audio_initial_volume',
    'autoPowerDownTime',
    'auto_framerate',
    'autoupdateURL',
    'autoupdate_cond',
    'betaupdate_cond',
    'controlModel',
    'defaultLedLevel',
    'dvb_type',
    'front_panel',
    'graphicres',
    'hdmi_event_delay',
    'lang_audiotracks',
    'lang_subtitles',
    'language',
    'mount_media_ro',
    'playerClock',
    'settMaster',
    'ssaverDelay',
    'ssaverName',
    'standByMode',
    'standbyLedLevel',
    'startPage',
    'subtitlesColor',
    'subtitlesSize',
    'subtitles_on',
    'syslog_srv',
    'teletext_charset',
    'teletext_on',
    'teletext_opacity',
    'teletext_ratio',
    'ts_endType',
    'ts_exitType',
    'ts_icon',
    'ts_lag',
    'ts_on',
    'ts_path',
    'ts_time',
    'tvsystem',
    'upnp_conf',
    'weather_conf',
    'weather_place',
    'audioPrimaryLanguage',
    'audioSecondaryLanguage',
    'subtitlesPrimaryLanguage',
    'subtitlesSecondaryLanguage',
    'timezone_conf',
    'ntpurl',
    'portal1',
    'portal2',
    'use_portal_dhcp',
    'force_dvi',
    'input_buffer_size',
    'cec',
    'igmp_conf',
    'portal_dhcp',
    'wifi_ssid',
    'wifi_auth',
    'wifi_enc',
    'wifi_psk',
    'wifi_wep_key1',
    'wifi_int_dns',
    'wifi_int_ip',
    'wifi_int_mask',
    'wifi_int_gw',
    'mc_proxy_enabled',
    'mc_proxy_url',
    'lan_noip',
    'ipaddr_conf',
    'dnsip',
    'pppoe_enabled',
    'pppoe_login',
    'pppoe_dns1',
    'update_url',
    'custom_url_hider',
    'useExtPortalsPage',
    'bootstrap_url',
    'update_channel_url',
    'audio_stereo_out_mode',
    'audio_dyn_range_comp',
    'audio_operational_mode',
    'audio_spdif_mode',
    'audio_hdmi_audio_mode',
    'wifi_wep_def_key',
    'wifi_wep_key1',
    'wifi_wep_key2',
    'wifi_wep_key3',
    'wifi_wep_key4',
    'gatewayip',
    'lan_noip',
    'netmask',
    'debug',
    'playerHardwareAcceleration'
]}));


try {
    environment = JSON.parse(environment);
    environment = environment.result;
} catch ( error ) {
    environment = {};
}

environment.language = environment.language || 'en';

environment.availableLanguages = [];

(function () {
    var index = 0,
        list = gSTB.RDir('tempfile read languages_utf8.txt').split('\n'),
        specificLanguages = {
            estoninan: {
                code: 'et',
                name: 'Estonian (Eesti keel)'
            },
            latvian: {
                code: 'lv',
                name: 'Latvian (Latviešu)'
            }
        },
        language, name;

    // YEAH! It's Legacy
    while ( index < list.length ) {
        if ( list[index] !== '' ) {
            /* eslint no-useless-escape: 0 */
            language = list[index].split('\"');
            // if ( language[1] === 'bg' || language[1] === 'es'  || language[1] === 'el' ) {
            //     name = language = language[1];
            // } else {
            name = decodeURIComponent(escape(language[3]));
            language = language[1];
            // }

            if ( language === specificLanguages.estoninan.code ) {
                specificLanguages.estoninan = false;
            }

            if ( language === specificLanguages.latvian.code ) {
                specificLanguages.latvian = true;
            }

            environment.availableLanguages.push({
                code: language,
                name: name
            });
        }
        ++index;
    }

    if ( specificLanguages.latvian ) {
        environment.availableLanguages.push(specificLanguages.latvian);
    }

    if ( specificLanguages.estoninan ) {
        environment.availableLanguages.push(specificLanguages.estoninan);
    }
})();

// set defaults if value empty
if ( environment.hdmi_event_delay === '' ) {
    environment.hdmi_event_delay = '3';
    window.gSTB.SetEnv(JSON.stringify({hdmi_event_delay: '3'}));
}

if ( environment.defaultLedLevel === '' ) {
    environment.defaultLedLevel = 10;
}

if ( environment.standbyLedLevel === '' ) {
    environment.standbyLedLevel = 100;
}

if ( environment.audioPrimaryLanguage === '' ) {
    environment.audioPrimaryLanguage = environment.language;
}

if ( environment.audioSecondaryLanguage === '' ) {
    environment.audioSecondaryLanguage = environment.language;
}

if ( environment.subtitlesPrimaryLanguage === '' ) {
    environment.subtitlesPrimaryLanguage = environment.language;
}

if ( environment.subtitlesSecondaryLanguage === '' ) {
    environment.subtitlesSecondaryLanguage = environment.language;
}

if ( environment.auto_framerate === '' ) {
    environment.auto_framerate = 'Disabled';
}

environment.onFocusDebounceTimeout = 300;

// if ( MODE === 'MINISTRA' ) {
//     window.gSTB.StandByMode = environment.standByMode = 1;
// }

// if ( window.gSTB.SetAutoPowerDownInitAttr ) {
//     window.gSTB.SetAutoPowerDownInitAttr(JSON.stringify({
//         url: url + 'standby/index.html',
//         backgroundColor: '#000'
//     }));

//     window.gSTB.SetAutoPowerDownTime(environment.autoPowerDownTime);
// }


module.exports = environment;
